import { cva } from "class-variance-authority";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";
import { Badge } from "./badge";

const statusTagVariants = cva("", {
  variants: {
    size: {
      small: "rounded-custom px-1 py-0.5 h-5",
      default: "px-2 py-1",
    },
  },
  defaultVariants: {
    size: "small",
  },
});

export type StatusTagProps = {
  status:
    | "not_started"
    | "in_progress"
    | "completed"
    | "skipped"
    | "fraud_suspicion"
    | "other";
  label?: string;
  className?: string;
  size?: "small" | "default";
};

const STATUS_STYLES: Record<StatusTagProps["status"], string> = {
  not_started: "bg-blue-100 text-blue-800",
  in_progress: "bg-yellow-100 text-yellow-800",
  completed: "bg-green-100 text-green-800",
  skipped: "bg-white text-gray-800 border border-gray-50",
  fraud_suspicion: "bg-gray-100 text-gray-800",
  other: "bg-gray-100 text-gray-800",
};

export const STATUS_LABELS: Record<StatusTagProps["status"], string> = {
  not_started: "Not started",
  in_progress: "In progress",
  completed: "Completed",
  skipped: "Skipped",
  fraud_suspicion: "Fraud suspicion",
  other: "Other",
};

export const StatusTag: React.FC<StatusTagProps> = ({
  status,
  label,
  className = "",
  size = "default",
}) => {
  const { t } = useTranslation();
  const tagClassName = STATUS_STYLES[status];
  const labelValue = label ?? STATUS_LABELS[status];

  return (
    <div>
      <Badge
        className={cn(
          "px-2 py-1 border-none whitespace-nowrap",
          tagClassName,
          statusTagVariants({ size }),
          className,
        )}
      >
        {t(labelValue)}
      </Badge>
    </div>
  );
};
